import { useFieldArray } from 'react-hook-form';
import { HistoricJob, SearchMeterPointDetails } from '../../types';
import { useStandingData } from '../../hooks/useStandingData';
import { TableItem } from '@portal_components/components/TableItem';
import { useState } from 'react';
import { FormCard } from '@portal_components/components/FormCard';
import { FormDatePicker } from '@portal_components/components/FormDatePicker';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { DateTime } from 'luxon';

export const JobHistoryTab = () => {
  const {
    standingData: { standingDataJobTypeList, standingDataJobStatusList, standingDataVisitOutcomeList }
  } = useStandingData();
  const { fields } = useFieldArray<SearchMeterPointDetails, 'jobHistory'>({ name: 'jobHistory' });
  const [expandedJobId, setExpandedJobId] = useState<string | null>(null);

  const renderHistoricJob = (job: HistoricJob, index: number) => (
    <div className="flex flex-col w-full">
      <TableItem
        key={job.jobId}
        expanded={expandedJobId === job.jobId}
        onExpandClicked={() => {
          setExpandedJobId(job.jobId === expandedJobId ? null : job.jobId);
        }}
      >
        <div className="pt-3">{standingDataJobTypeList.find(e => e.value === job.jobTypeId)?.title}</div>
        <div className="pt-3">{standingDataJobStatusList.find(e => e.value === job.jobStatusId)?.title}</div>
        <div className="pt-3">
          {standingDataVisitOutcomeList.find(e => e.value === job.visitOutcome)?.title}
        </div>
        <div className="pt-3">
          {DateTime.fromISO(job.actualVisitDate ?? job.scheduledDatetime).toFormat('dd/MM/yyyy')}
        </div>
      </TableItem>
      {expandedJobId === job.jobId && (
        <FormCard columns={2} borderLeftOnly>
          <FormTextInput title="Job ID" name={`jobHistory.${index}.jobId`} readonly />
          <FormDatePicker title="Booking Date" name={`jobHistory.${index}.bookingDatetime`} readonly />
          <FormDatePicker title="Actual Visit Date" name={`jobHistory.${index}.actualVisitDate`} readonly />
          <FormDatePicker title="Scheduled Date" name={`jobHistory.${index}.scheduledDatetime`} readonly />
          <FormTextInput title="Assigned Operative" name={`jobHistory.${index}.assignedOperative`} readonly />
          <FormTextInput title="Booking Comments" name={`jobHistory.${index}.bookingComments`} readonly />
          <FormTextInput title="Field Comments" name={`jobHistory.${index}.fieldComments`} readonly />
          <FormTextInput title="Tech Notes" name={`jobHistory.${index}.techNotes`} readonly />
          <FormTextInput title="job Duration" name={`jobHistory.${index}.jobDuration`} readonly />
        </FormCard>
      )}
    </div>
  );

  return (
    <FormCard>
      <div
        className={`grid grid-flow-col auto-cols-fr pl-4 pt-3 mb-1 pb-1 items-start w-11/12 border-b-[2px] border-b-secondary-deep-blue-80`}
      >
        <p className="truncate hover:text-clip">Job Type</p>
        <p className="truncate hover:text-clip">Job Status</p>
        <p className="truncate hover:text-clip">Visit Outcome</p>
        <p className="truncate hover:text-clip">Visit Date</p>
      </div>
      {fields.map(renderHistoricJob)}
    </FormCard>
  );
};
